import {ServicesBeneficios} from './ServicesBeneficios';
export default ServicesBeneficios;